import React from 'react';
import moment from 'moment';
import { Colors } from '_styles';
import { getBoardingOffsetMinutes } from '../utils/flight-time';

/**
 * Content for hover overlay on boarding flight cards.
 * Displays flight number, scheduled time, boarding time, and operating time.
 */
const BoardingFlightTimeModal = ({ flightData, flightState, iata }) => {
    if (!flightData && !flightState) return null;

    const flightNumber = flightState?.displayFlightNumber || flightData?.flightNumber || 'N/A';
    const scheduledTime = flightData?.scheduled
        ? moment(new Date(flightData.scheduled)).format('HH:mm')
        : 'N/A';
    const operatingTime = flightData?.operationInfo?.time || flightData?.operationTime
        ? moment(new Date(flightData.operationInfo?.time || flightData.operationTime)).format('HH:mm')
        : 'N/A';

    const boardingTimeIso = flightData?.manualLockBoarding && flightData?.manualBoardingTime
        ? flightData.manualBoardingTime
        : flightData?.boardingTime
            ? flightData.boardingTime
            : (flightData?.operationTime || flightData?.flightFeedTime)
                ? new Date(new Date(flightData.operationTime || flightData.flightFeedTime).getTime()
                    - getBoardingOffsetMinutes(flightData, iata) * 60 * 1000).toISOString()
                : null;
    const boardingTime = boardingTimeIso ? moment(new Date(boardingTimeIso)).format('HH:mm') : 'N/A';

    const rows = [
        { label: 'Flight', value: flightNumber },
        { label: 'Scheduled', value: scheduledTime },
        { label: 'Boarding', value: boardingTime },
        { label: 'Operating', value: operatingTime },
    ];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {rows.map(({ label, value }) => (
                <div
                    key={label}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 16,
                        fontSize: 11,
                        lineHeight: 1.4,
                        color: Colors.TEXT_DARK,
                    }}
                >
                    <span style={{ fontWeight: 600, color: Colors.GRAY_DARK }}>{label}:</span>
                    <span>{value}</span>
                </div>
            ))}
        </div>
    );
};

export default BoardingFlightTimeModal;
